import React, { useMemo, useState } from "react";
import countryList from "react-select-country-list";
import FormData from "form-data";
import {
  Layout,
  Input,
  Button,
  Card,
  Typography,
  Form,
  message,
  Select,
  Steps,
  InputNumber,
  Divider,
  Upload,
  Progress,
} from "antd";
import { UploadOutlined, RightOutlined } from "@ant-design/icons"
import { profileconfig } from "../../configurations/profileconfig";
import { UserRegistrationUpdate } from "./api";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { utilities } from "../../utilities/utlities";
export default function ThirdStep(props) {
  const { Content } = Layout;
  const { Title, Text, Link } = Typography;
  const [Countryvalue, setValue] = useState("");
  const [varCountry, setVatCountry] = useState("");
  const [fileLoading, setFileLOading] = useState(0);
  const { Step } = Steps;
  const { Option } = Select;
  const loggedUser = utilities.loggedUser();
  const [errorMessage, setError] = useState(false)
  var options = useMemo(() => countryList().getLabels(), []);

  const [userData, setUser] = useState()
  React.useEffect(() => {
    setUser(props.userdata)

  }, [props.userdata, userData])

  const NextStep = () => {
    if (userData?.comapnyname == undefined) {
      setError(true)
      return;
    }
    if (userData?.companyWebsite == undefined) {
      setError(true)
      return;
    }
    if (userData?.country == undefined) {
      setError(true)
      return;
    }
    if (userData?.city == undefined) {
      setError(true)
      return;
    }
    if (userData?.street == undefined) {
      setError(true)
      return;
    }
    if (userData?.postalcode == undefined) {
      setError(true)
      return;
    }

    if (loggedUser != null && loggedUser.type == "distributor") {
      if (userData?.numberofEmployee == undefined) {
        setError(true)
        return;
      }
      if (userData?.compnayPhone == undefined) {
        setError(true)
        return;
      }
      if (userData?.tradeLicense == undefined) {
        setError(true)
        return;
      }
      if (userData?.trnCertificate == undefined) {
        setError(true)
        return;
      }

    }
    else {
      if (userData?.vatcountry == undefined) {
        setError(true)
        return;
      }
      if (userData?.Vatnumber == undefined) {
        setError(true)
        return;
      }
      if (userData?.registrationNumber == undefined) {
        setError(true)
        return;
      }
      if (userData?.gmpCertficate == undefined) {
        setError(true)
        return;
      }
      if (userData?.manufacturingLicense == undefined) {
        setError(true)
        return;
      }
      if (userData?.siteMasterFile == undefined) {
        setError(true)
        return;
      }
      if (userData?.detailedCompanyProfile == undefined) {
        setError(true)
        return;
      }
      if (userData?.certificatesOfGoodManufacturingPractices == undefined) {
        setError(true)
        return;
      }
      if (userData?.certificatesOfRegistration == undefined) {
        setError(true)
        return;
      }
    }
    setError(true)

    if (loggedUser != null && loggedUser.type != "distributor") {
      props.CompleteRegistration(4)
    } else {
      props.CompleteRegistration(3, 'COMPLETE')
    }

  };
  const fileUpload = (value, type, name,label2) => {
    const { onSuccess, onError, file, onProgress } = value;
    const formData = new FormData();
    formData.append("document", value.file);
    formData.append(type, 1);
    const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
    var userType = "";
    if (loggedUser.type == "distributor") {
      userType = "distributor";
    } else {
      userType = "supplier";
    }
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: loggedUser.jwtToken,
      },
      onUploadProgress: (event) => {
        const percent = Math.floor((event.loaded / event.total) * 100).toFixed(2);
        setFileLOading(percent);
        if (percent === 100) {
          setTimeout(() => setFileLOading(0), 1000);
        }
        onProgress({ percent: ((event.loaded / event.total) * 100).toFixed(2) });
      },
    };
    UserRegistrationUpdate.uploadFiles(
      userType,
      formData,
      loggedUser.jwtToken,
      config,
      (err, data) => {
        if (data != null) {
          props.updateUser(data)
          message.success("Your File Upload Successfully", 3);
          props.updateCompanyDetails(type, 1, '',label2);
          onSuccess("ok");
        } else {
          message.error("Please ! Try again", 3);
          onError("Something Wrong");
        }
      }
    );
  };
  return (
    <Card style={{ width: 300 }} bordered={true} className="login-container">
      <Form
        autoComplete="off"
        className="loginForm"
        layout="vertical"
        name="nest-messages"
        onFinish={() => { }}
        validateMessages={() => { }}
      >
        {
          profileconfig[loggedUser?.type]['3'].fields.map((item, index) => {
            if (item?.type == 'Label') {
              return <Form.Item>
                <Title level={5}>
                  {item.label}
                </Title>
              </Form.Item>
            }
            else if (item?.type == "Text" || item?.type == "Number") {
              if(item?.name == "street"){
              }
              return <Form.Item
                className={item.itemclass}
                rules={[
                  {
                    required: true,
                    message: "Please input your First Name",
                  },
                ]}
              >  <Text>{item?.label}</Text>
                {item?.require == true ? <Text type="danger">*</Text> : null}
                <Input
                  id={item.id}
                  size={item.size}
                  disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                  className={`${props?.objectKeys?.includes(item.label2) == true ? 'warningMessage' : ''}`}
                  onChange={(e) => {
                    props.updateCompanyDetails(item.key, e.target.value, item.name,item?.label2)
                  }}
                  value={userData?.[item.name]}
                />
                {errorMessage == true ? (item?.require == true && props.userdata?.[item.name] == '') || item?.require == true && props.userdata?.[item.name] == undefined ? <Text type="danger">{item?.errorMessage}</Text> : null : null}

              </Form.Item>
            }
            else if (item?.type == "Phone") {
              return <Form.Item
                className={item.itemclass}
                rules={[
                  {
                    required: true,
                    message: "Please input your Phone Number",
                  },
                ]}
              >  <Text>{item?.label}</Text>
                {item?.require == true ? <Text type="danger">*</Text> : null}
                <PhoneInput
                  disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                  className={`${props?.objectKeys?.includes(item.label2) == true ? 'warningMessage' : ''}`}
                  value={userData?.[item.name]}
                  country='pk'
                  id="regPhone"
                  onChange={(Phone) => {
                    props.updateCompanyDetails(item.key, `+${Phone}`, item.name,item?.label2)
                  }
                  }

                />
                {errorMessage == true ? (item?.require == true && props.userdata?.[item.name] == '') || item?.require == true && props.userdata?.[item.name] == '' ? <Text type="danger">{item?.errorMessage}</Text> : null : null}
              </Form.Item>
            }
            else if (item?.type == "Select") {
              return <Form.Item
                className={item.itemclass}
                onChange={(e) => {
                }}
                rules={[
                  {
                    required: true,
                    message: "Please input your Country",
                  },
                ]}
              > <Text>{item?.label}</Text>
                {item?.require == true ? <Text type="danger">*</Text> : null}
                <Select
                  disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                  className={`${props?.objectKeys?.includes(item.label2) == true ? 'warningMessage' : ''}`}
                  showSearch
                  value={userData?.[item.name]}
                  id={item.id}
                  size="large"
                  placeholder="Select"
                  onChange={(e) => {
                    setValue(e);
                    // props.selectCountry(e);
                    props.updateCompanyDetails(item.key, e, item.name,item?.label2);
                  }}
                  allowClear
                >
                  {options.map((item, index) => {
                    return <Option value={item}>{item} </Option>;
                  })}
                </Select>
                {errorMessage == true ? (item?.require == true && props.userdata?.[item.name] == '') || (item?.require == true && props.userdata?.[item.name] == undefined) ? <Text type="danger">{item?.errorMessage}</Text> : null : null}
              </Form.Item>
            }
            else if (item?.type == "Upload") {
              return <Form.Item
                className={item.itemclass}

                rules={[
                  {
                    required: true,
                    message: "Please input your Tax Registration",
                  },
                ]}
              >
                {props.userdata?.[item.name] != undefined ?
                  <>
                    <Text>{item?.label}</Text>
                    {item?.require == true ? <Text type="danger">*</Text> : null}
                    <br>


                    </br>
                    <Upload
                      progress={{
                        strokeColor: {
                          "0%": "#108ee9",
                          "100%": "#87d068",
                        },
                      }}
                      id={item.id}
                      accept="pdf"
                      customRequest={(file) => {
                        fileUpload(file, item.key, item.name,item.label2);
                      }}
                      onRemove={() => {
                        fileUpload('', item.key, item.name,item.label2);
                      }}
                      maxCount={1}
                      defaultFileList={[{
                        uid: index,
                        name: props?.userdata?.[item?.name].name,
                        url: props?.userdata?.[item?.name].url,
                      }]}
                    >
                      <Button icon={<UploadOutlined />}
                       disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                        className={`${props?.objectKeys?.includes(item.label2) == true ? 'warningMessage' : ''}`}
                      >Click to Upload</Button>
                      {errorMessage == true ? (item?.require == true && props.userdata?.[item.name] == '') || (item?.require == true && props.userdata?.[item.name] == undefined) ? <Text type="danger">{item?.errorMessage}</Text> : null : null}
                    </Upload></>
                  : <>
                    <Text>{item?.label}</Text>
                    {item?.require == true ? <Text type="danger">*</Text> : null}
                    <br></br>
                    <Upload
                      progress={{
                        strokeColor: {
                          "0%": "#108ee9",
                          "100%": "#87d068",
                        },
                      }}
                      onRemove={() => {
                        fileUpload('', item.key, item.name,item?.label2);
                      }}
                      maxCount={1}
                      id={item.id}
                      accept="pdf"
                      customRequest={(file) => {
                        fileUpload(file, item.key, item.name,item?.label2);
                      }}
                    >
                      <Button icon={<UploadOutlined />}
                        disabled={props?.loginUser?.profileCompleted == false ? false:props?.objectKeys?.includes(item.label2)== true && userData?.[item.name] != undefined ? false:true}
                        className={`${props?.objectKeys?.includes(item.label2) == true ? 'warningMessage' : ''}`}
                      >Click to Upload</Button>
                    </Upload>
                  </>
                }
                {errorMessage == true ? (item?.require == true && props.userdata?.[item.name] == '') || (item?.require == true && props.userdata?.[item.name] == undefined) ? <Text type="danger">{item?.errorMessage}</Text> : null : null}
              </Form.Item>

            }
            else {
              return <Form.Item className={item?.itemclass}>
                <Button
                  type="primary"
                  className={item.elementclass}
                  size={item.size}
                  loading={props.loading}
                  onClick={() => {
                    NextStep()
                  }}
                >
                  {item.label} <RightOutlined />
                </Button>
              </Form.Item>
            }
          })

        }      </Form>
    </Card>
  );
}
